$(document).ready(function () {

            // Tab Append
            $('.appendtabfea').appendTo('#tab-fea-0');
            $('.appendtablatest').appendTo('#tab-latest-0');
            $('.appendtabbest').appendTo('#tab-best-0');

            // Slideshow
            $('.owl-slider').slick({
                dots: true,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1
            });

            // special products
            $('.wbspeprod').slick({
                dots: false,
                arrows: true,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2   
                    }
                }
             ]
            });  
            $(".wbspeprod").show();

            // Home Tab Product   
            $('.newcoll').slick({     
                dots: false,
                arrows: true,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
            $(".newcoll").show();


            // Product Category 
            if ($(window).width() >= 768) {
            $(".ptabbr1").slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 5000,
                slidesToShow: 4,
                slidesToScroll: 1  
            });
           };
            $(".ptabbr1").show();
            $('.ptabbr1 a.nav-link').click(function () {
                $('.ptabbr1 a.nav-link').addClass('active');
                $('.ptabbr1 a.nav-link').removeClass('active');
            });
            $('.owl-procat1').slick({
                dots: false,
                arrows: true,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
            $(".owl-procat1").show();



            // Product With Banner
            $('.wbprobnrtop').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                autoplay: false,
                dots: false,
                fade: true,
                asNavFor: '.wbprobnrbtm'
            });
            $('.wbprobnrbtm').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                infinite: false,
                asNavFor: '.wbprobnrtop',
                dots: true,
                arrows: false
            });
            $(".wbprobnrtop").show();
            $(".wbprobnrbtm").show();


            // Testimonial
            $('.testi').slick({
                dots: true,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            $(".testi").show();

    // Lookbook Active
    $(document).on('click', '.wblookbtn', function(e) {
        $('.wblookbtn').removeClass('active');
        $(this).toggleClass('active');
        $('.wblookbleft').removeClass('active');
        $('#wblook'+$(this).attr('target')).toggleClass('active');
    });

    // Blog
    $('.wbblog').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
  	$(".wbblog").show();

    // Logo Slider
    $('.wblogobar').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 7
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3
            }
        }
        ]
    });
  	$(".wblogobar").show();

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $('#scroll').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
        $('.wbmegamainhd').on('click', function() {
            var targetMenu = '#' + $(this).data('submenu');
            $(targetMenu).slideToggle(300);
            $(this).toggleClass('active');
            return false;
        });
        $('#megamenu').prependTo('.wblogo');
        $('localization-form #FooterCountryForm').appendTo('.slidedown_section .dropdown-menu');
    };


    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#product-grid').addClass('product-list').removeClass('product-grid');
        } else if ($(this).hasClass('gridv')) {
            $('#product-grid').addClass('product-grid').removeClass('product-list');
        }
    });

    // contdown timer



$('[data-countdown]').each(function() {
var $this = $(this), finalDate = $(this).data('countdown');
Date.prototype.yyyymmdd = function() {
var yyyy = this.getFullYear().toString();
var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
var dd = this.getDate().toString();
return yyyy + "/" + (mm[1]?mm:"0"+mm[0]) + "/" + (dd[1]?dd:"0"+dd[0]); // padding
};



var date = new Date();
if (finalDate > date.yyyymmdd()){
$(this).parents('.timer_outer').css('display','block');
}else{
$(this).parents('.timer_outer').css('display','none');
}



$this.countdown(finalDate, function(event) {
$this.html(event.strftime('<li class="displayformat"><span>%D</span><p>Days</p></li><li class="displayformat"><span>%H</span><p>Hours</p></li><li class="displayformat"><span>%M</span><p>Mins</p></li><li class="displayformat"><span>%S</span><p>Secs</p></li>'));
});

});


    // Popup Product
    $('.wbpopup-popducts .popinner').hide();
    var i = 0;
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval( setIntervalFun, totalTimer);
    function setIntervalFun()
    {
        $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
        setTimeout(function(){
            $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
            i++;
            if ($('.wbpopup-popducts .popinner').length <= i) {
                i = 0;
            }
        },parseInt(7000));
    }
    $(document).on('click', '.wbclosepopup', function(){
        $('.wbpopup-popducts').fadeOut(400).remove();
    });


    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 
    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
    e.preventDefault();
    $('.wbinnerclr').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });
    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){ 
    e.preventDefault();
    $('.wbrtlmode').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });
    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });


}); // Document Ready Div End


$(window).on('load',function(){
    $(".s-panel .loader").removeClass("wrloader");
});

/* for desktop */
function w3_openbar() {
    document.getElementById("myOverlaybar").style.display = "block";
    document.getElementById("wbheadsbar").className = "active";
    $('body').addClass("wbbodyscroll");
}

function w3_closebar() {
    document.getElementById("myOverlaybar").style.display = "none";
    document.getElementById("wbheadsbar").className = "";
    $('body').removeClass("wbbodyscroll");
}

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "";
    $('body').removeClass("wbbodyscroll");
}

